// extracted by mini-css-extract-plugin
module.exports = {"WrapPage":"serviceType-list-screen_WrapPage__2_5u6"};